import { render } from "./company-profile-input.vue?vue&type=template&id=6124998a&scoped=true"
import script from "./company-profile-input.vue?vue&type=script&lang=js"
export * from "./company-profile-input.vue?vue&type=script&lang=js"

import "./company-profile-input.vue?vue&type=style&index=0&id=6124998a&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/hkust-gz-vitals/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6124998a"]])

export default __exports__